import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-download",
  "use": "icon-download-usage",
  "viewBox": "0 0 1024 768",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 768\" id=\"icon-download\"><path fill=\"#ffffff\" d=\"M768 768H224q-93 0-158.5-65.5T0 544q0-84 55-147t137-74v-3q0-87 43-160.5T351.5 43T512 0q100 0 180.5 56T809 202q94 24 154.5 101.5T1024 480q0 111-74 193.5T768 768m-76-320H576V288q0-13-9.5-22.5T544 256h-64q-13 0-22.5 9.5T448 288v160H332q-8 0-11 14.5t5 23.5l167 145q8 9 19 9t19-9l167-145q8-9 5-23.5T692 448\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol